// "Status changed: 12d ago" for a Workflow card, aged green -> orange -> red.
//
// Restored from before commit 06ee17a, which rewrote WorkflowPage onto
// /api/workflow/items/ and dropped both this helper and the chip it feeds.
// Thresholds are the originals: a card sitting in one column past a month is
// worth noticing, past two months is worth chasing.
//
// Pure and separate from the page so the boundaries can be tested directly --
// same reason filterPrefs.js lives here rather than inline.

export function getStatusAge(isoString, now = Date.now()) {
  if (!isoString) return null;

  const then = new Date(isoString).getTime();
  if (Number.isNaN(then)) return null;

  const diffMs = now - then;
  // A future timestamp means clock skew between the server and this browser,
  // not a card that changed tomorrow. Say nothing rather than "-3d ago".
  if (diffMs < 0) return null;

  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  let label;
  if (diffMins < 1) label = 'Just now';
  else if (diffMins < 60) label = `${diffMins}m ago`;
  else if (diffHours < 24) label = `${diffHours}h ago`;
  else label = `${diffDays}d ago`;

  let color;
  if (diffDays <= 30) color = '#107d59ff';       // green
  else if (diffDays <= 60) color = '#c98818ff';  // orange
  else color = '#d22d2dff';                      // red

  return { label, color };
}
